var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.666016C4.39199 0.666016 0.666992 4.39102 0.666992 8.99935C0.666992 13.6077 4.39199 17.3327 9.00033 17.3327C13.6087 17.3327 17.3337 13.6077 17.3337 8.99935C17.3337 4.39102 13.6087 0.666016 9.00033 0.666016ZM13.167 11.991L11.992 13.166L9.00033 10.1743L6.00866 13.166L4.83366 11.991L7.82533 8.99935L4.83366 6.00768L6.00866 4.83268L9.00033 7.82435L11.992 4.83268L13.167 6.00768L10.1753 8.99935L13.167 11.991Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMark);
export default __webpack_public_path__ + "static/media/close-mark.e021f3b73fbb27318befc2dcd2710521.svg";
export { ForwardRef as ReactComponent };